import { I4BCellType, I4BColumnConfiguration } from './configurations/i4b-column-configuration';
import { getDefaultColumnsByConcept } from './default-columns.registry';
import { I4BTopicsButtonColumn } from './definitions';
import { I4BBasicColumn } from './definitions/i4b-basic.column';
import { I4BColumn } from './definitions/i4b-column';
import { I4bCellConcept } from './enums';
import { TopicsGridData } from './models';
import { HeaderType, I4BColumnHeader } from './models/i4b-column-header.model';
import { I4BGridOptions } from './models/i4b-grid-options.model';
import { I4BGrid } from './models/i4b-grid.model';
import { I4BColumnOptions } from './options/i4b-column-options';

export const GET_DEFAULT_TOPICS_COLUMNS_FOR_TOPICS_VIEW = (): I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] => [
  new I4BBasicColumn(
    { displayName: 'NAME', type: HeaderType.BASIC },
    {
      id: 'name',
      isDefault: true,
      sortProperty: 'name',
      translationKey: 'IOT_DICTIONARY.NAME',
      concept: I4bCellConcept.TOPICS,
      isLink: true,
      cell: { type: I4BCellType.BASIC_LINK, event: { type: 'navigate' } }
    },
    { order: 1 }
  ),
  new I4BBasicColumn(
    { displayName: 'ENTITY', type: HeaderType.BASIC },
    {
      id: 'entity.name',
      isDefault: true,
      sortProperty: 'entity.name',
      translationKey: 'IOT_DICTIONARY.ENTITY',
      concept: I4bCellConcept.TOPICS,
      cell: { type: I4BCellType.BASIC }
    },
    { order: 2 }
  ),
  new I4BBasicColumn(
    { displayName: 'VIEW', type: HeaderType.BASIC },
    {
      id: 'view',
      isDefault: true,
      sortProperty: 'view',
      translationKey: 'IOT_DICTIONARY.VIEW',
      concept: I4bCellConcept.TOPICS,
      cell: { type: I4BCellType.TRANSLATED_CELL, options: { translateKey: 'IOT_DICTIONARY.' } }
    },
    { order: 3 }
  ),
  new I4BBasicColumn(
    { displayName: 'EMAIL TEMPLATE', type: HeaderType.BASIC },
    {
      id: 'emailTemplateId',
      isDefault: true,
      sortProperty: 'emailTemplateId',
      translationKey: 'MASTER_VIEW_ENGINE.TABLE.HEADER_NAME.EMAIL_TEMPLATE',
      concept: I4bCellConcept.TOPICS,
      cell: { type: I4BCellType.EMAIL_TEMPLATE }
    },
    { order: 4 }
  ),
  new I4BBasicColumn(
    { displayName: 'CREATED BY', type: HeaderType.BASIC },
    {
      id: 'createdBy',
      isDefault: true,
      sortProperty: 'createdBy',
      translationKey: 'IOT_DICTIONARY.CREATED_BY',
      concept: I4bCellConcept.TOPICS,
      cell: { type: I4BCellType.USER_CELL }
    },
    { order: 5 }
  ),
  new I4BBasicColumn(
    { displayName: 'SUBSCRIBERS', type: HeaderType.BASIC },
    {
      id: 'totalSubscribers',
      isDefault: true,
      sortProperty: 'totalSubscribers',
      translationKey: 'TOPICS.DETAIL_POPUP.SUBSCRIBERS',
      concept: I4bCellConcept.TOPICS,
      cell: { type: I4BCellType.NUMBER }
    },
    { order: 5 }
  ),

  new I4BBasicColumn(
    { displayName: 'STATUS', type: HeaderType.BASIC },
    {
      id: 'status',
      isDefault: true,
      sortProperty: 'status',
      translationKey: 'IOT_DICTIONARY.STATUS',
      concept: I4bCellConcept.TOPICS,
      cell: {
        type: I4BCellType.BASIC,
        options: {
          capitalize: true,
          translatedValues: {
            active: { color: '#262836', backgroundColor: 'rgba(164, 255, 0, 0.1)', value: 'Active' },
            inactive: { color: '#262836', backgroundColor: 'rgba(255, 0, 99, 0.1)', value: 'Inactive' }
          }
        }
      }
    },
    { order: 6 }
  ),
  new I4BBasicColumn(
    { displayName: 'ESCALATION PROTOCOLS', type: HeaderType.BASIC },
    {
      id: 'totalEscalationProtocols',
      isDefault: true,
      sortProperty: 'totalEscalationProtocols',
      translationKey: 'TOPICS.SHELL.ESCALATION_PROTOCOLS',
      concept: I4bCellConcept.TOPICS,
      cell: { type: I4BCellType.NUMBER }
    },
    { order: 7 }
  ),
  new I4BBasicColumn(
    { displayName: 'SUBSCRIPTION DATE', type: HeaderType.BASIC },
    {
      id: 'subscribedAt',
      isDefault: true,
      sortProperty: 'subscribedAt',
      translationKey: 'TOPICS.SHELL.SUBSCRIPTION_DATE',
      concept: I4bCellConcept.TOPICS,
      cell: { type: I4BCellType.DATE }
    },
    { order: 8 }
  ),
  new I4BBasicColumn(
    { displayName: 'SUBSCRIPTION DATE', type: HeaderType.BASIC },
    {
      id: 'id',
      isDefault: true,
      concept: I4bCellConcept.TOPICS,
      cell: { type: I4BCellType.TOPIC_SELF_SUBSCRIPTION_CELL, event: { type: 'switchSubscription' }, valueGetter: 'totalSubscribers' }
    },
    { order: 9, pinned: 'right', width: 80 }
  )
];

export class DefaultTopicsGrid implements I4BGrid<I4BGridOptions, TopicsGridData> {
  masterview = 'topics';
  isDefault = true;
  isUserDefault = true;
  isAppDefault = true;
  name = 'topics';
  userId = '';
  data: TopicsGridData = {
    response: {
      data: [],
      pagination: null
    }
  };
  gridOptions: I4BGridOptions = {
    pageSize: 100,
    multipleSelection: false,
    autoRefresh: { enabled: false },
    buttonColumn: { enabled: true, className: new I4BTopicsButtonColumn() },
    gridSort: []
  };
  columns: I4BColumn<I4BColumnHeader, I4BColumnConfiguration, I4BColumnOptions>[] = [...getDefaultColumnsByConcept(this.masterview)];
}
